import { Country } from '@resurs-internal/mui/assets/countries';

import { getAuthSession, headers } from '@/helpers';
import {
  type BbanBankNameRequest,
  BbanBankNameRequestCountryCode,
  type BbanBankNameResponse,
  type BbanValidationRequest,
  type BbanValidationRequestCountryCode,
} from '@/types/consumer-deposit-application-service';

const BBANUrl = `${import.meta.env.VITE_RESURS_EKS_HOST}/api/consumer_deposit_application_service/bban`;

export const lookupBankName = async (
  countryCode: Country,
  accountPrefix: string,
) =>
  putLookupBankName({
    accountPrefix,
    countryCode: countryToCountryCode(countryCode),
  });

const countryToCountryCode = (
  country: Country,
): BbanBankNameRequestCountryCode => {
  if (Object.values(Country).includes(country)) {
    return BbanBankNameRequestCountryCode[
      country as keyof typeof BbanBankNameRequestCountryCode
    ];
  } else {
    return BbanBankNameRequestCountryCode.UNKNOWN;
  }
};

const putLookupBankName = async (
  request: BbanBankNameRequest,
): Promise<BbanBankNameResponse> => {
  const { accessToken } = getAuthSession();

  return fetch(`${BBANUrl}/bank_name`, {
    body: JSON.stringify(request),
    headers: headers(accessToken),
    method: 'PUT',
  }).then(async (response) => {
    if (response.status !== 200) {
      const res = await response.json();

      throw Error(res.message);
    } else {
      return response.json();
    }
  });
};

export const validateBBAN = async (
  countryCode: Country,
  accountPrefix = '',
  accountNumber: string,
) =>
  putValidateBBAN({
    accountNumber,
    accountPrefix,
    countryCode: countryToCountryCode(
      countryCode,
    ) as unknown as BbanValidationRequestCountryCode,
  });

const putValidateBBAN = async (request: BbanValidationRequest) => {
  const { accessToken } = getAuthSession();

  return fetch(`${BBANUrl}/validate`, {
    body: JSON.stringify(request),
    headers: headers(accessToken),
    method: 'PUT',
  }).then(async (response) => {
    if (response.status !== 200) {
      const res = await response.json();

      throw Error(res.message);
    } else {
      return Promise.resolve();
    }
  });
};
